<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue'

const bodyClass = 'beta-modal-portals-active'

onMounted(() => document.body.classList.add(bodyClass))
onBeforeUnmount(() => document.body.classList.remove(bodyClass))
</script>

<template>
    <div class="beta-modal-layer">
        <slot></slot>
    </div>
</template>

<style scoped>
:global(body.beta-modal-portals-active #headlessui-portal-root) {
    position: relative;
    z-index: 200;
}
</style>
